module.exports = __webpack_public_path__ + "img/one.9a9d67d9.jpg";